<template>
  <!-- 特约摄影师 -->
  <div>
    <div class="bg-round bg-fff">
      <div class="container">
        <div class="bg-fff pa-tb-30">
          <Bread :list="breadList" />
        </div>

        <div class="flex f-center ma-t-30">
          <div class="width60">
            <div class="fon-26">什么是特约摄影师</div>
            <div class="describe ma-t-20">
              翠麟创作人社区为华语新一代青年影像创作者进阶专业领域提供平台与方法，这里是一个可以展现个人才华,自我提升,职业进阶,寻找伙伴,分享生活,聚集创意的互联网社区平台。SHISW翠麟国际电影（短片）奖大赛是通FilmFreeway官方认证的国际电影赛事。<br>
              为了给广大华语青年影像创作者提供展示才华、获得专业媒体宣传，进阶专业领域的平台，翠麟创作人社区与《摄影与摄像》杂志联合发起“特约摄像师”认证项目。
            </div>
          </div>
          <div class="width40 flex f-center f-jcenter">
            <img
              src="../img/Photographer/20220317184239.png"
              alt=""
              srcset=""
              width="60%"
            />
          </div>
        </div>

        <div class="flex f-center ma-t-40">
          <div class="width40 flex f-center f-jcenter">
            <img
              src="../img/Photographer/组 13.png"
              alt=""
              srcset=""
              width="70%"
            />
          </div>
          <div class="width60 describe">
            <div class="fon-26 c-000">《摄影与摄像》杂志</div>
            创刊于1995年2月，是中国科学技术协会主管、中国科教电影电视协会主办的国家级市场刊物，是我国第一本同时涵括摄影与摄像内容、国内外公开发行的国家级刊物，现已对接万方数据库，可评职称。
            《摄影与摄像》杂志是一本具有学术品质的市场期刊，读者群为影视行业人士、高校师生、热爱摄影的旅游人士和热爱中国传统文化人士等。
            国际标准刊号：1006-4788 国内统一刊号：11-3625/TB 邮发代号：82-683
            国外代号：6214-MO 开张页码：16开160页
          </div>
        </div>

        <div class="ma-t-80">
          <div class="t-center fon-26 width100">尊享权益</div>
          <div class="ma-t-20 width100 t-center">
            翠麟创作人社区&《摄影与摄像》杂志
          </div>
          <div class="flex f-between ma-t-20">
            <div class="width20 t-center">
              <img src="../img/Photographer/s31.png" alt="" srcset="" />
              <div class="pa-tb-10">精英人才库</div>
              <div class="c-666">
                邀请加入翠麟影像精英人才库，获得官网推荐与宣传
              </div>
            </div>
            <div class="width20 t-center">
              <img src="../img/Photographer/s32.png" alt="" srcset="" />
              <div class="pa-tb-10">专属微信群</div>
              <div class="c-666">
                邀请加入“特约摄像师”俱乐部（微信群），扩展人脉，结识好友
              </div>
            </div>
            <div class="width20 t-center">
              <img src="../img/Photographer/s33.png" alt="" srcset="" />
              <div class="pa-tb-10">短片奖评选</div>
              <div class="c-666">优秀作品将受邀参加翠麟国际短片奖评选</div>
            </div>
            <div class="width20 t-center">
              <img src="../img/Photographer/s34.png" alt="" srcset="" />
              <div class="pa-tb-10">展映交流活动</div>
              <div class="c-666">
                优秀作品邀请参加相关主题展映交流活动（线上/线下）
              </div>
            </div>
          </div>

          <div class="flex f-between ma-t-20">
            <div class="width20 t-center">
              <img src="../img/Photographer/s35.png" alt="" srcset="" />
              <div class="pa-tb-10">作品销售代理</div>
              <div class="c-666">优秀作品获得国际销售代理</div>
            </div>
            <div class="width20 t-center">
              <img src="../img/Photographer/s36.png" alt="" srcset="" />
              <div class="pa-tb-10">工作推荐</div>
              <div class="c-666">优秀作者申请获得相关工作经纪/推荐的机会</div>
            </div>
            <div class="width20 t-center">
              <img src="../img/Photographer/s37.png" alt="" srcset="" />
              <div class="pa-tb-10">专属证书</div>
              <div class="c-666">
                获得《摄影与摄像》杂志颁发的“特约摄像师”证书，即获“特约摄像师”的专业身份
              </div>
            </div>
            <div class="width20 t-center">
              <img src="../img/Photographer/s38.png" alt="" srcset="" />
              <div class="pa-tb-10">免费登载作品</div>
              <div class="c-666">
                《摄影与摄像》杂志官网与官方公众号平台，不定期免费登载作品
              </div>
            </div>
          </div>

          <div class="flex f-between ma-t-20">
            <div class="width20 t-center">
              <img src="../img/Photographer/s39.png" alt="" srcset="" />
              <div class="pa-tb-10">首席特约摄像师</div>
              <div class="c-666">
                每年将从“特约摄像师”中评选出《摄影与摄像》“首席特约摄像师”，并颁发证书，获得相应权益
              </div>
            </div>
            <div class="width20 t-center">
              <img src="../img/Photographer/s40.png" alt="" srcset="" />
              <div class="pa-tb-10">协会会员</div>
              <div class="c-666">
                优秀者将邀请加入中国科教电影电视协会影像活动专业委员会成为会员
              </div>
            </div>
            <div class="width20 t-center">
              <img src="../img/Photographer/s41.png" alt="" srcset="" />
              <div class="pa-tb-10">优惠作品刊登</div>
              <div class="c-666">杂志刊登版面（图/文广告宣传）获8.8折</div>
            </div>
            <div class="width20 t-center">
              <img src="../img/Photographer/s42.png" alt="" srcset="" />
              <div class="pa-tb-10">获得翠麟荣誉桂冠</div>
              <div class="c-666">用于作品标识与展示</div>
            </div>
          </div>
        </div>

        <div>
          <div class="t-center fon-26 width100 ma-t-80">资料</div>
          <div class="flex f-between ma-t-40">
            <div class="pa-20 bg-red-box b-r-15">
              <div class="b-b-1-fff b-r-15 c-fff height100">
                <div class="t-center ma-t-20">申请要求</div>
                <div class="pa-20">
                  <div class="ma-t-10 flex f-center">
                    <img
                      src="../img/Photographer/whitePeach.png"
                      alt=""
                      srcset=""
                      class="ma-r-10"
                    />
                    热爱影像事业，具备专业的摄影/摄像器材;
                  </div>
                  <div class="ma-t-10 flex f-center">
                    <img
                      src="../img/Photographer/whitePeach.png"
                      alt=""
                      srcset=""
                      class="ma-r-10"
                    />具有一定的专业技能和职业素养;
                  </div>
                  <div class="ma-t-10 flex f-center">
                    <img
                      src="../img/Photographer/whitePeach.png"
                      alt=""
                      srcset=""
                      class="ma-r-10"
                    />在摄影/摄像类相关的报纸、期刊、专业网络媒体/视频平台上发表过署名的作品；或获得过摄影/摄像类专业奖项者。
                  </div>
                </div>
              </div>
            </div>
            <div class="pa-20 bg-red-box b-r-15">
              <div class="b-b-1-fff b-r-15 c-fff height100">
                <div class="t-center ma-t-20">认证资料</div>
                <div class="pa-20">
                  <div class="ma-t-10 flex f-center">
                    <img
                      src="../img/Photographer/whitePeach.png"
                      alt=""
                      srcset=""
                      class="ma-r-10"
                    />本人免冠电子照片1张；
                  </div>
                  <div class="ma-t-10 flex f-center">
                    <img
                      src="../img/Photographer/whitePeach.png"
                      alt=""
                      srcset=""
                      class="ma-r-10"
                    />刊发过作品或获奖作品的证明（相关证书、相片/截图、网址链接等）;
                  </div>
                  <div class="ma-t-10 flex f-center">
                    <img
                      src="../img/Photographer/whitePeach.png"
                      alt=""
                      srcset=""
                      class="ma-r-10"
                    />个人简历1份（1000字以内）。
                  </div>
                  <div class="ma-t-10 flex f-center">
                    <img
                      src="../img/Photographer/whitePeach.png"
                      alt=""
                      srcset=""
                      class="ma-r-10"
                    />提交本人平面摄影作品5幅；影像作品至少1部。（上述所有资源提供百度网盘链接，下载期限设置为永久）;
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ma-t-40">
        <div class="apply-for c-fff pa-t-30">
          <div class="t-center fon-26 ma-t-40">申请流程</div>
          <div class="ma-t-60 step-bar container">
            <div class="dotted"></div>
            <div class="t-center flex f-between step-bar-itembox">
              <div class="width20">
                <img src="../img/Photographer/1.png" alt="" srcset="" />
                <div class="ma-t-20">提交申请资料</div>
              </div>
              <div class="width20">
                <img src="../img/Photographer/2.png" alt="" srcset="" />
                <div class="ma-t-20">支付认证费398元/年</div>
              </div>
              <div class="width20">
                <img src="../img/Photographer/3.png" alt="" srcset="" />
                <div class="ma-t-20">3 - 5个工作日内查看认证结果</div>
              </div>
              <div class="width20">
                <img src="../img/Photographer/4.png" alt="" srcset="" />
                <div class="ma-t-20">认证通过后，每月月底统一快递证书</div>
              </div>
            </div>
          </div>
          <div class="other-step-bar">
            <div class="apply-btn c-p" @click="getUserInfo()">
              申请认证
            </div>
            <div class="pa-tb-20 t-center">版权声明</div>
            <div class="flex f-jcenter">
              <div>
                <div>
                  *报名者所提交的相关作品，需确保相关版权无有争议，如出现任何版权相关问题，均由报名者个人负责，与我方无关。
                </div>
                <div class="ma-t-10">
                  *我方有权使用报名者所提交的作品，用于本项目的相关宣传/展示/推广，无需另行通知作者本人。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 报名弹框 -->
    <el-dialog
      title="申请加入"
      center
      :visible.sync="dialogVisibleApply"
      width="30%"
      custom-class="pa-20"
    >
      <div class="ma-t-30">
        <div class="flex f-center">
          <div class="width30">姓名：</div>
          <el-input v-model="formData.Name" placeholder="请输入姓名"></el-input>
        </div>
        <div class="flex f-center ma-t-20">
          <div class="width30">联系电话：</div>
          <el-input
            v-model="formData.Phone"
            placeholder="请输入联系电话"
          ></el-input>
        </div>
        <div class="flex f-center ma-t-20">
          <div class="width30">网盘链接：</div>
          <el-input
            v-model="formData.diskUrl"
            placeholder="请输入网盘链接"
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleApply = false">取 消</el-button>
        <el-button type="primary" @click="applyAdd()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 支付弹框二维码 -->
    <el-dialog
      :visible.sync="paydialogVisiblePay"
      width="30%"
      @before-close="paydialogVisiblePay = false"
    >
      <div>
        <payment
          :payKey="pay.Key"
          @paySuccess="paySuccess"
          v-if="paydialogVisiblePay"
        ></payment>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { PhotographerApplyAdd, getuser } from "../api.js";
import payment from "../components/payment.vue";
export default {
  components:{
    payment
  },
  data() {
    return {
      breadList: [
        {
          name: "特约摄影师",
          path: "",
        },
      ],
      dialogVisibleApply: false,
      paydialogVisiblePay:false,
      formData: {
        Name: "",
        Phone: "",
        diskUrl:""
      },
      pay: {
        Amount: 0,
        Key: "",
        SN: "",
      },
    };
  },
  created() {
    
  },
  methods: {
    //获取用户信息
    getUserInfo(){
      getuser().then((res) => {
        this.formData.Name = res.data.Data.Name;
        this.formData.Phone = res.data.Data.Phone;
        this.dialogVisibleApply = true
    });
    },
    //申请加入
    applyAdd() {
      if (!this.formData.Name) {
        return this.$message.error("姓名不能为空");
      }
      if (!this.formData.Phone) {
        return this.$message.error("联系电话不能为空");
      }
      if (!this.formData.diskUrl) {
        return this.$message.error("网盘链接不能为空");
      }
      PhotographerApplyAdd(this.formData)
        .then((res) => {
          this.pay = res.data.Data;
          this.paydialogVisiblePay=true;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //支付成功
    paySuccess(){
      this.dialogVisibleApply = false;
      this.paydialogVisiblePay = false;
    }
  },
};
</script>

<style scoped>
.describe {
  color: #666666;
  line-height: 40px;
}
.bg-red-box {
  background: #fb004d;
  box-sizing: border-box;
  width: 49%;
}
.b-b-1-fff {
  border: 1px solid #fff;
}
.apply-for {
  height: 600px;
  width: 100%;
  background: url("../img/Photographer/s5.png");
  background-size: cover;
}
.step-bar {
  position: relative;
}
.dotted {
  border: 1px dashed #fff;
  position: absolute;
  width: 80%;
  top: 35px;
  left: 10%;
}
.step-bar-itembox {
  position: absolute;
  width: 100%;
}
.other-step-bar {
  margin: 250px auto 0 auto;
}
.apply-btn {
  width: 410px;
  height: 60px;
  background: #fb004d;
  border-radius: 30px;
  text-align: center;
  line-height: 60px;
  margin: 0 auto;
}
</style>